import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
  NgModuleRef,
  InjectionToken,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { InstrumentsManagerApiClient } from './services';
import { InstrumentsManagerApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    instrumentsManagerApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    instrumentsManagerApiConfig: InstrumentsManagerApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken(
  'InstrumentsManagerApiModule Config Factory',
);

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [InstrumentsManagerApiClient],
})
export class InstrumentsManagerApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => InstrumentsManagerApiConfig,
  ): ModuleWithProviders<InstrumentsManagerApiModule> {
    return {
      ngModule: InstrumentsManagerApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: InstrumentsManagerApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error(
        'InstrumentsManagerApiModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => InstrumentsManagerApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new InstrumentsManagerApiConfig(
          cfgMgr.withBase(cfgMgr.getRawConfig('instrumentsManagerApiConfig')),
        );
    cfgMgr.addApiConfig('instrumentsManagerApiConfig', config);
  }
}
